import PushNotificationsTable from './PushNotificationsTable';

export default PushNotificationsTable;
